import React, { lazy } from 'react';

/**
 * Wraps dynamic imports for React.lazy with defensive handling.
 * Prevents "Cannot read properties of undefined (reading 'default')" when chunks
 * fail to load or modules resolve unexpectedly (e.g. circular deps, race conditions).
 *
 * Use this for ALL lazy imports (routes, heavy components like RichTextEditor, etc.).
 * Supports both default and named exports.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyRoute(importFn: () => Promise<any>): React.LazyExoticComponent<React.ComponentType<any>> {
  return lazy(async () => {
    const m = (await importFn()) as Record<string, unknown> | undefined;
    const C = m?.default ?? (m && typeof m === 'object' ? Object.values(m)[0] : undefined);
    if (!C || typeof C !== 'function') {
      throw new Error('Route chunk failed to load. Try refreshing or clearing cache.');
    }
    return { default: C as React.ComponentType<Record<string, unknown>> };
  });
}
